import Listing from 'data/listing';
import { checkIfEnoughData, endDate, startDate } from 'utils/data-vis-helpers';
import endpoint from 'utils/endpoint';
import logger from 'utils/logger';


export type Stats = {
  data: Record<string, unknown>[];
};

export const getStatsForListing = async (listing: Listing, abortSignal?: AbortSignal): Promise<[Stats | null, Stats | null]> => {
  try {
    const city = listing.city?.toLowerCase();
    const neighbourhood = listing.neighbourhoodName?.toLowerCase();

    // Set up both requests to run in parallel
    const requests = [
      // City stats request
      endpoint<Stats>('/stats', 'GET', {
        municipality: city,
        dateStart: startDate,
        dateEnd: endDate,
        homeType: '',
      }, undefined, abortSignal, 'https://stats.zoocasa.com'),
    ];

    // Add neighborhood request if we have a neighborhood
    if (neighbourhood) {
      requests.push(
        endpoint<Stats>('/stats', 'GET', {
          dateStart: startDate,
          dateEnd: endDate,
          municipality: city,
          neighbourhood,
        }, undefined, abortSignal, 'https://stats.zoocasa.com')
      );
    }

    // Run all requests in parallel
    const [cityStatsResponse, neighbourhoodResponse = null] = await Promise.all(requests);
    return [cityStatsResponse, neighbourhoodResponse];
  } catch (error) {
    logger.error(error, 'Error fetching stats:');
    return [null, null];
  }
};

